import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import { ArrowLeft, CheckCircle2, MapPin, Radar, Star, X } from "lucide-react";
import mehak from "../../../../assets/Mehak.png";
import image1 from "../../../../assets/Yogit.png";
import image2 from "../../../../assets/driver1.webp";
import image3 from "../../../../assets/driver2.webp";
import { useNavigate } from "react-router-dom";
import { VEHICLE_IMAGES } from "../../../../Utils/Vehicleimg";
import { GlobalContext } from "../../../../Context/GlobalContext";
import useCustomerDetails from "../../../Services/Customer/useCustomerDetails";

const CITY_COORDINATES = {
  Delhi: {
    lat: 28.6139,
    lng: 77.209,
  },
  Noida: {
    lat: 28.5355,
    lng: 77.391,
  },
  Gaziabad: {
    lat: 28.6692,
    lng: 77.4538,
  },
  Ghaziabad: {
    lat: 28.6692,
    lng: 77.4538,
  },
  Gurugram: {
    lat: 28.4595,
    lng: 77.0266,
  },
};

const CaptainSearchingCard = ({
  formData,
  selectedVehicle = "Two Wheeler",
  baseFare = 0,
  onBack,
  onNext,
  vehicleMeta,
}) => {
  const [selectedExtra, setSelectedExtra] = useState(0);
  const [isAccepted, setIsAccepted] = useState(false);
  const [acceptedDriver, setAcceptedDriver] = useState(null);
  const [searchCount, setSearchCount] = useState(1);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [lastClickedExtra, setLastClickedExtra] = useState(null);
  const mapRef = useRef(null);
  const googleMapRef = useRef(null);
  const pickupMarkerRef = useRef(null);
  const dropMarkerRef = useRef(null);
  const driverMarkersRef = useRef([]);
  const radiusCircleRef = useRef(null);
const radiusWaveRef = useRef(null);

const parcelId = formData?.parcelId || "";
console.log("PARCEL ID RECEIVED:", formData?.parcelId);

  const navigate = useNavigate();

  const MAX_SEARCH_COUNT = 55;
  const SEARCH_RADIUS_METERS = 2400;

  const selectedCity =
    formData?.city || sessionStorage.getItem("selectedCity") || "Delhi";

  const selectedCityCenter =
    CITY_COORDINATES[selectedCity] || CITY_COORDINATES.Delhi;
  const { car, truck, auto, bike } = VEHICLE_IMAGES;

  const cancellationReasons = [
    "Changed my mind",
    "Pickup address is wrong",
    "Drop address is wrong",
    "Fare is too high",
    "Taking too much time",
    "Booked by mistake",
    "Other reason",
  ];

  const autoAcceptTargetRef = useRef(
    Math.floor(Math.random() * MAX_SEARCH_COUNT) + 1,
  );

  const extraOptions = [10, 20, 30, 50];

 const vehicleBaseFare = useMemo(() => {
  return Number(baseFare || 0);
}, [baseFare]);



  const totalPrice = useMemo(() => {
    return Number(vehicleBaseFare || 0) + Number(selectedExtra || 0);
  }, [vehicleBaseFare, selectedExtra]);

  const getVehicleIcon = () => {
    const name = String(selectedVehicle || "").toLowerCase();

    if (name.includes("three") || name.includes("auto")) return auto;

    if (
      name.includes("four") ||
      name.includes("eeco") ||
      name.includes("car")
    ) {
      return car;
    }

    if (name.includes("truck") || name.includes("mini")) return truck;

    return bike;
  };

  const vehicleIcon = getVehicleIcon();

  const fakeDrivers = [
    {
      id: 1,
      name: "Mehak Aggarwal",
      rating: "4.8",
      distance: "1.2 km",
      eta: "4 mins",
      top: "18%",
      left: "48%",
      delay: "0s",
      move: "driver-move-1",
      image: mehak,
    },
    {
      id: 2,
      name: "Amit Singh",
      rating: "4.7",
      distance: "1.8 km",
      eta: "6 mins",
      top: "32%",
      left: "68%",
      delay: "0.3s",
      move: "driver-move-2",
      image: image1,
    },
    {
      id: 3,
      name: "Deepak Sharma",
      rating: "4.9",
      distance: "2.1 km",
      eta: "7 mins",
      top: "46%",
      left: "25%",
      delay: "0.6s",
      move: "driver-move-3",
      image: image2,
    },
    {
      id: 4,
      name: "Mohit Verma",
      rating: "4.6",
      distance: "2.4 km",
      eta: "8 mins",
      top: "60%",
      left: "58%",
      delay: "0.9s",
      move: "driver-move-1",
      image: image3,
    },
    {
      id: 5,
      name: "Ravi Kumar",
      rating: "4.8",
      distance: "2.8 km",
      eta: "9 mins",
      top: "70%",
      left: "36%",
      delay: "1.2s",
      move: "driver-move-2",
      image: image1,
    },
    {
      id: 6,
      name: "Vikas Yadav",
      rating: "4.7",
      distance: "3.0 km",
      eta: "10 mins",
      top: "38%",
      left: "43%",
      delay: "1.5s",
      move: "driver-move-3",
      image: image2,
    },
  ];

  const cleanNumber = (value, fallback) => {
    const number = Number(value);

    return Number.isFinite(number) ? number : fallback;
  };

  const pickupLocation = useMemo(() => {
    return {
      lat: cleanNumber(
        formData?.pickupLatitude ||
          formData?.pickupLat ||
          formData?.pickup_latitude,
        selectedCityCenter.lat,
      ),
      lng: cleanNumber(
        formData?.pickupLongitude ||
          formData?.pickupLng ||
          formData?.pickup_longitude,
        selectedCityCenter.lng,
      ),
    };
  }, [formData, selectedCityCenter]);

  const dropLocation = useMemo(() => {
    const hasDropLat =
      formData?.dropLatitude || formData?.dropLat || formData?.drop_latitude;

    const hasDropLng =
      formData?.dropLongitude || formData?.dropLng || formData?.drop_longitude;

    return {
      lat: cleanNumber(
        hasDropLat,
        hasDropLng ? pickupLocation.lat : pickupLocation.lat + 0.018,
      ),
      lng: cleanNumber(
        hasDropLng,
        hasDropLat ? pickupLocation.lng : pickupLocation.lng + 0.018,
      ),
    };
  }, [formData, pickupLocation]);

  const getDriverPositionInsideRadius = (driverIndex) => {
    const centerLat = Number(pickupLocation.lat);
    const centerLng = Number(pickupLocation.lng);

    const angle = (driverIndex * 58 + 25) * (Math.PI / 180);

    const distanceMeters = 450 + driverIndex * 220;

    const earthRadius = 6378137;

    const latOffset = (distanceMeters * Math.cos(angle)) / earthRadius;

    const lngOffset =
      (distanceMeters * Math.sin(angle)) /
      (earthRadius * Math.cos((centerLat * Math.PI) / 180));

    return {
      lat: centerLat + (latOffset * 180) / Math.PI,
      lng: centerLng + (lngOffset * 180) / Math.PI,
    };
  };

  const createAnimatedVehicleOverlay = ({
    map,
    position,
    vehicleIcon,
    driver,
    index,
    isDimmed,
    isAcceptedDriver,
  }) => {
    const animationClasses = [
      "vehicle-animate-up-down",
      "vehicle-animate-left-right",
      "vehicle-animate-diagonal-one",
      "vehicle-animate-diagonal-two",
    ];

    const selectedAnimation = animationClasses[index % animationClasses.length];

    const overlay = new window.google.maps.OverlayView();

    overlay.onAdd = function () {
      const div = document.createElement("div");

      div.className = `map-vehicle-marker ${selectedAnimation} ${
        isAcceptedDriver ? "vehicle-accepted" : ""
      } ${isDimmed ? "vehicle-dimmed" : ""}`;

      div.innerHTML = `
      <div class="map-vehicle-marker-inner ${
        isAcceptedDriver ? "driver-accepted-pulse" : ""
      }">
        <img src="${vehicleIcon}" alt="${driver.name}" />
      </div>
    `;

      div.title = driver.name;

      div.addEventListener("click", () => {
        const infoWindow = new window.google.maps.InfoWindow({
          content: `
          <div style="font-family:Arial; min-width:150px;">
            <b>${driver.name}</b>
            <div style="font-size:12px; margin-top:4px;">
              Rating: ${driver.rating} ⭐<br/>
              Distance: ${driver.distance}<br/>
              ETA: ${driver.eta}
            </div>
          </div>
        `,
        });

        infoWindow.setPosition(position);
        infoWindow.open(map);
      });

      overlay.div = div;

      const panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(div);
    };

    overlay.draw = function () {
      const projection = this.getProjection();

      if (!projection || !overlay.div) return;

      const point = projection.fromLatLngToDivPixel(
        new window.google.maps.LatLng(position.lat, position.lng),
      );

      if (!point) return;

      overlay.div.style.left = `${point.x}px`;
      overlay.div.style.top = `${point.y}px`;
    };

    overlay.onRemove = function () {
      if (overlay.div && overlay.div.parentNode) {
        overlay.div.parentNode.removeChild(overlay.div);
      }

      overlay.div = null;
    };

    overlay.setMap(map);

    return overlay;
  };

  const createRadiusWaveOverlay = ({ map, center, radiusMeters }) => {
  const overlay = new window.google.maps.OverlayView();

  overlay.onAdd = function () {
    const div = document.createElement("div");

    div.className = "radius-wave-overlay";

    div.innerHTML = `
      <div class="radius-wave-ring radius-wave-ring-1"></div>
      <div class="radius-wave-ring radius-wave-ring-2"></div>
      <div class="radius-wave-ring radius-wave-ring-3"></div>
    `;

    overlay.div = div;

    const panes = this.getPanes();
    panes.overlayLayer.appendChild(div);
  };

  overlay.draw = function () {
    const projection = this.getProjection();

    if (!projection || !overlay.div) return;

    const centerPoint = projection.fromLatLngToDivPixel(
      new window.google.maps.LatLng(center.lat, center.lng)
    );

    const edgePoint = projection.fromLatLngToDivPixel(
      window.google.maps.geometry.spherical.computeOffset(
        new window.google.maps.LatLng(center.lat, center.lng),
        radiusMeters,
        90
      )
    );

    if (!centerPoint || !edgePoint) return;

    const radiusPx = Math.abs(edgePoint.x - centerPoint.x);
    const size = radiusPx * 2;

    overlay.div.style.left = `${centerPoint.x - radiusPx}px`;
    overlay.div.style.top = `${centerPoint.y - radiusPx}px`;
    overlay.div.style.width = `${size}px`;
    overlay.div.style.height = `${size}px`;
  };

  overlay.onRemove = function () {
    if (overlay.div && overlay.div.parentNode) {
      overlay.div.parentNode.removeChild(overlay.div);
    }
    overlay.div = null;
  };

  overlay.setMap(map);

  return overlay;
};

  const loadGoogleMap = () => {
    const googleKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    if (!googleKey) {
      console.error("Google Maps API key missing in .env");
      return;
    }

    if (window.google?.maps) {
      initMap();
      return;
    }

    const existingScript = document.getElementById("google-maps-script");

    if (existingScript) {
      existingScript.addEventListener("load", initMap);
      return;
    }

    const script = document.createElement("script");
    script.id = "google-maps-script";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleKey}&libraries=geometry`;
    script.async = true;
    script.defer = true;
    script.onload = initMap;

    document.body.appendChild(script);
  };

  const initMap = () => {
    if (!mapRef.current || !window.google?.maps) return;

    if (!googleMapRef.current) {
      googleMapRef.current = new window.google.maps.Map(mapRef.current, {
        center: pickupLocation,
        zoom: 13,
        disableDefaultUI: true,
        zoomControl: true,
        fullscreenControl: true,
        streetViewControl: false,
        mapTypeControl: false,
      });
    }

    renderMapMarkers();
  };

  const clearMapItems = () => {
    if (pickupMarkerRef.current) {
      pickupMarkerRef.current.setMap(null);
    }

    if (dropMarkerRef.current) {
      dropMarkerRef.current.setMap(null);
    }

    if (radiusCircleRef.current) {
      radiusCircleRef.current.setMap(null);
    }

    if (radiusWaveRef.current) {
  radiusWaveRef.current.setMap(null);
  radiusWaveRef.current = null;
}
    driverMarkersRef.current.forEach((marker) => marker.setMap(null));
    driverMarkersRef.current = [];
  };

  const renderMapMarkers = () => {
    if (!window.google?.maps || !googleMapRef.current) return;

    const map = googleMapRef.current;

    clearMapItems();

    /**
     * Always keep radius circle / pickup location in exact map center.
     * Do not use fitBounds here, otherwise circle moves outside/edge.
     */
    const centerPosition = {
      lat: Number(pickupLocation.lat),
      lng: Number(pickupLocation.lng),
    };

    map.panTo(centerPosition);
    map.setZoom(13);
  
      // Radius circle around pickup/current location.
    radiusCircleRef.current = new window.google.maps.Circle({
  map,
  center: centerPosition,
  radius: SEARCH_RADIUS_METERS,
  strokeColor: "#2563eb",
  strokeOpacity: 0.22,
  strokeWeight: 1,
  fillColor: "#2563eb",
  fillOpacity: 0.03,
});

radiusWaveRef.current = createRadiusWaveOverlay({
  map,
  center: centerPosition,
  radiusMeters: SEARCH_RADIUS_METERS,
});

    pickupMarkerRef.current = new window.google.maps.Marker({
      map,
      position: centerPosition,
      title: "Pickup Location",
      label: {
        text: "P",
        color: "#ffffff",
        fontWeight: "700",
      },
      icon: {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 13,
        fillColor: "#2563eb",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 4,
      },
    });

    dropMarkerRef.current = new window.google.maps.Marker({
      map,
      position: dropLocation,
      title: "Drop Location",
      label: {
        text: "D",
        color: "#ffffff",
        fontWeight: "700",
      },
      icon: {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 12,
        fillColor: "#16a34a",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 3,
      },
    });

    fakeDrivers.forEach((driver, index) => {
      const position = getDriverPositionInsideRadius(index);

      const accepted = isAccepted && acceptedDriver?.id === driver.id;

      const animatedVehicleOverlay = createAnimatedVehicleOverlay({
        map,
        position,
        vehicleIcon,
        driver,
        index,
        isDimmed: isAccepted && !accepted,
        isAcceptedDriver: accepted,
      });

      driverMarkersRef.current.push(animatedVehicleOverlay);
    });
  };

  useEffect(() => {
    loadGoogleMap();
  }, []);

  useEffect(() => {
    if (window.google?.maps && googleMapRef.current) {
      renderMapMarkers();
    }
  }, [pickupLocation, dropLocation, isAccepted, acceptedDriver, vehicleIcon]);

  const handleCancelConfirm = () => {
    if (!cancelReason) return;

    setShowCancelModal(false);
    setCancelReason("");

    navigate("/two-wheeler");
  };

  useEffect(() => {
    if (isAccepted) return;

    const interval = setInterval(() => {
      setSearchCount((prev) => {
        const nextCount = prev + 1;

        if (
          prev >= autoAcceptTargetRef.current ||
          nextCount > MAX_SEARCH_COUNT
        ) {
          clearInterval(interval);

          const randomDriver =
            fakeDrivers[Math.floor(Math.random() * fakeDrivers.length)];

          setAcceptedDriver(randomDriver);
          setIsAccepted(true);

          setTimeout(() => {
            if (onNext) {
              onNext({
                acceptedDriver: randomDriver,
                selectedExtra,
                totalPrice,
              });
            }
          }, 1200);

          return prev;
        }

        return nextCount;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isAccepted, onNext, selectedExtra, totalPrice]);

  const handleExtraClick = async (amount) => {
  if (isAccepted) return;

  const response = await addTipToFareApi({
    parcelId,
    tipAmount: amount,
  });

  if (response?.responseCode === "00") {
    setSelectedExtra((prev) =>
      Number(prev || 0) + Number(amount || 0)
    );

    setLastClickedExtra(amount);
  }
};

  const { userCode } = useContext(GlobalContext);
const { addTipToFareApi, addTipToFareLoading } =
  useCustomerDetails();

  const searchProgress = Math.min((searchCount / MAX_SEARCH_COUNT) * 100, 100);

  return (
    <>
      <style>
        {`
          @keyframes acceptedPulse {
            0%, 100% {
              transform: scale(1);
              box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.35);
            }
            50% {
              transform: scale(1.08);
              box-shadow: 0 0 0 14px rgba(34, 197, 94, 0);
            }
          }

          .driver-accepted-pulse {
            animation: acceptedPulse 1.4s ease-in-out infinite;
          }

          @keyframes vehicleMoveUpDown {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-16px);
  }
}

@keyframes vehicleMoveLeftRight {
  0%, 100% {
    transform: translateX(0px);
  }
  50% {
    transform: translateX(18px);
  }
}

@keyframes vehicleMoveDiagonalOne {
  0%, 100% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(14px, -14px);
  }
}

@keyframes vehicleMoveDiagonalTwo {
  0%, 100% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(-14px, 14px);
  }
}

@keyframes vehicleFloatPulse {
  0%, 100% {
    scale: 1;
  }
  50% {
    scale: 1.08;
  }
}

.map-vehicle-marker {
  position: absolute;
  width: 42px;
  height: 42px;
  transform: translate(-50%, -50%);
  pointer-events: auto;
  cursor: pointer;
  z-index: 20;
}

.map-vehicle-marker-inner {
  width: 42px;
  height: 42px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: vehicleFloatPulse 1.6s ease-in-out infinite;
}

.map-vehicle-marker-inner img {
  width: 31px;
  height: 31px;
  object-fit: contain;
}

.vehicle-animate-up-down {
  animation: vehicleMoveUpDown 2.4s ease-in-out infinite;
}

.vehicle-animate-left-right {
  animation: vehicleMoveLeftRight 2.7s ease-in-out infinite;
}

.vehicle-animate-diagonal-one {
  animation: vehicleMoveDiagonalOne 3s ease-in-out infinite;
}

.vehicle-animate-diagonal-two {
  animation: vehicleMoveDiagonalTwo 3.2s ease-in-out infinite;
}

.vehicle-accepted {
  z-index: 50;
}

.vehicle-dimmed {
  opacity: 0.35;
}

@keyframes radiusWavePulse {
  0% {
    transform: scale(0.08);
    opacity: 0.85;
    border-width: 8px;
    box-shadow:
      0 0 18px rgba(37, 99, 235, 0.5),
      inset 0 0 22px rgba(37, 99, 235, 0.18);
  }

  45% {
    opacity: 0.45;
    border-width: 5px;
    box-shadow:
      0 0 22px rgba(37, 99, 235, 0.32),
      inset 0 0 20px rgba(37, 99, 235, 0.12);
  }

  75% {
    opacity: 0.18;
    border-width: 3px;
    box-shadow:
      0 0 16px rgba(37, 99, 235, 0.16),
      inset 0 0 12px rgba(37, 99, 235, 0.07);
  }

  100% {
    transform: scale(1);
    opacity: 0;
    border-width: 1px;
    box-shadow:
      0 0 0 rgba(37, 99, 235, 0),
      inset 0 0 0 rgba(37, 99, 235, 0);
  }
}

.radius-wave-overlay {
  position: absolute;
  pointer-events: none;
  border-radius: 9999px;
  transform-origin: center;
  z-index: 2;
}

.radius-wave-ring {
  position: absolute;
  inset: 0;
  border-radius: 9999px;
  border-style: solid;
  border-color: rgba(37, 99, 235, 0.55);
  background: radial-gradient(
    circle,
    rgba(37, 99, 235, 0.18) 0%,
    rgba(37, 99, 235, 0.1) 28%,
    rgba(37, 99, 235, 0.04) 58%,
    rgba(37, 99, 235, 0) 100%
  );
  animation: radiusWavePulse 2.8s ease-out infinite;
}

.radius-wave-ring-1 {
  animation-delay: 0s;
}

.radius-wave-ring-2 {
  animation-delay: 0.9s;
}

.radius-wave-ring-3 {
  animation-delay: 1.8s;
}

        `}
      </style>

      <section className="w-full px-3 pb-6 pt-8 sm:px-4 md:px-6 md:pt-12 lg:px-0 lg:pt-0">
        <div className="mx-auto mt-10 grid w-full max-w-[1020px] grid-cols-1 overflow-hidden rounded-[26px] border border-white/80 bg-white shadow-[0_22px_70px_rgba(15,23,42,0.16)] sm:mt-4 md:mt-10 lg:mt-[120px] lg:h-[800px] lg:grid-cols-[57%_43%]">
          {/* LEFT */}
          <div className="order-2 flex h-full min-h-0 flex-col overflow-y-auto bg-white px-5 py-6 sm:px-7 lg:order-1 lg:px-7 lg:py-5 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
            <div className="w-full">
              <button
                type="button"
                onClick={onBack}
               disabled={isAccepted || addTipToFareLoading}
                className={`mb-3 inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50 ${
                  isAccepted ? "cursor-not-allowed opacity-50" : ""
                }`}
              >
                <ArrowLeft size={17} />
                Back to Fare
              </button>

              <div
                className={`mb-3 rounded-2xl px-4 py-3 ${
                  isAccepted
                    ? "border border-green-100 bg-green-50"
                    : "border border-orange-100 bg-orange-50"
                }`}
              >
                <div className="mb-3 flex items-start justify-between gap-3">
                  <div>
                    <p className="text-[16px] font-bold text-slate-800">
                      {isAccepted
                        ? "Captain accepted your order"
                        : `${searchCount} of ${MAX_SEARCH_COUNT} captains searched`}
                    </p>

                    <p className="mt-1 text-xs text-slate-500">
                      {isAccepted
                        ? `${acceptedDriver?.name} accepted your order. Redirecting...`
                        : "Searching nearby captains for your order."}
                    </p>
                  </div>

                  {isAccepted ? (
                    <CheckCircle2 size={24} className="text-green-600" />
                  ) : (
                    <Radar size={24} className="text-orange-500" />
                  )}
                </div>

                <div className="h-2 w-full overflow-hidden rounded-full border bg-white">
                  <div
                    className={`h-full rounded-full transition-all duration-700 ${
                      isAccepted ? "bg-green-500" : "bg-orange-400"
                    }`}
                    style={{
                      width: isAccepted ? "100%" : `${searchProgress}%`,
                    }}
                  />
                </div>
              </div>

              {isAccepted && acceptedDriver && (
                <div className="mb-3 rounded-2xl border border-green-100 bg-white px-4 py-3 shadow-sm">
                  <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                      <div className="flex h-13 w-13 items-center justify-center rounded-full bg-green-100 ring-4 ring-green-50">
                        <img
                          src={vehicleIcon}
                          alt={selectedVehicle}
                          className="h-10 w-10 object-contain"
                        />
                      </div>

                      <div>
                        <h4 className="font-bold text-slate-900">
                          {acceptedDriver.name}
                        </h4>

                        <div className="mt-1 flex items-center gap-2 text-sm text-slate-500">
                          <span className="inline-flex items-center gap-1">
                            <Star
                              size={14}
                              className="fill-yellow-400 text-yellow-400"
                            />
                            {acceptedDriver.rating}
                          </span>
                          <span>•</span>
                          <span>{acceptedDriver.distance}</span>
                          <span>•</span>
                          <span>{acceptedDriver.eta}</span>
                        </div>
                      </div>
                    </div>

                    <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-bold text-green-700">
                      Accepted
                    </span>
                  </div>
                </div>
              )}

              <div className="mb-3 flex items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-3">
                <div className="flex items-center gap-3">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-orange-300 bg-orange-50">
                    <img
                      src={vehicleIcon}
                      alt={selectedVehicle}
                      className="h-11 w-11 object-contain"
                    />
                  </div>

                  <div>
                    <h4 className="font-bold text-slate-800">
                      {selectedVehicle}
                    </h4>
         <p className="text-sm text-slate-500">
  Upto {vehicleMeta?.weight || 0} kg
</p>
                  </div>
                </div>

                <div className="text-right">
                  <p className="text-sm text-slate-500">Total Price</p>
                  <h3 className="text-[20px] font-bold text-slate-900">
                    ₹{totalPrice}
                  </h3>
                </div>
              </div>

              <div
                className={`mb-3 rounded-2xl border px-4 py-3 ${
                  isAccepted
                    ? "border-slate-200 bg-slate-50"
                    : "border-slate-200 bg-white"
                }`}
              >
                <div className="mb-3 flex items-start justify-between gap-3">
                  <div>
                    <div className="mb-1 flex items-center gap-2">
                      <span className="text-xl">🎯</span>
                      <h4 className="font-bold text-slate-800">
                        Increase your chances by adding extra
                      </h4>
                    </div>

                    <p className="text-sm leading-5 text-slate-500">
                      {isAccepted
                        ? "Captain accepted this order. Extra fare is locked."
                        : "Add extra fare so captains are more likely to accept your order quickly."}
                    </p>
                  </div>

                  {!isAccepted && selectedExtra > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedExtra(0);
                        setLastClickedExtra(null);
                      }}
                      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-500 hover:bg-slate-200"
                    >
                      <X size={16} />
                    </button>
                  )}
                </div>

                <div className="flex flex-wrap gap-3">
                  {extraOptions.map((amount) => (
                    <button
                      key={amount}
                      type="button"
                      disabled={isAccepted}
                      onClick={() => handleExtraClick(amount)}
                      className={`rounded-full px-4 py-2 text-sm font-bold transition ${
                        lastClickedExtra === amount
                          ? "bg-[#1f2d3f] text-white shadow-md"
                          : "bg-blue-50 text-slate-800 hover:bg-blue-100"
                      } ${
                        isAccepted
                          ? "cursor-not-allowed opacity-60"
                          : "cursor-pointer"
                      }`}
                    >
                      +₹{amount}
                    </button>
                  ))}
                </div>

                {selectedExtra > 0 && (
                  <div className="mt-3 rounded-xl bg-green-50 px-3 py-2 text-sm text-green-700">
                    Extra ₹{selectedExtra} added. New total is{" "}
                    <b>₹{totalPrice}</b>.
                  </div>
                )}
              </div>

              <div className="mb-3 rounded-2xl border border-slate-200 bg-white">
                <div className="flex items-center justify-between border-b px-4 py-3">
                  <h3 className="text-[17px] font-bold text-slate-800">
                    Delivery Info
                  </h3>

                  <button
                    type="button"
                    onClick={onBack}
                    disabled={isAccepted}
                    className={`font-bold text-slate-800 ${
                      isAccepted ? "cursor-not-allowed opacity-50" : ""
                    }`}
                  >
                    Edit Address
                  </button>
                </div>

                <div className="px-4 py-4">
                  <div className="relative flex gap-3">
                    <div className="relative flex w-6 shrink-0 flex-col items-center">
                      <span className="mt-2 h-3 w-3 rounded-full border-2 border-blue-500 bg-white" />

                      <span className="my-1 h-[52px] border-l-2 border-dashed border-slate-300" />

                      <span className="flex h-4 w-4 items-center justify-center rounded-full bg-green-600 text-white">
                        <MapPin size={11} fill="currentColor" />
                      </span>
                    </div>

                    <div className="flex-1 space-y-3">
                      <div className="min-h-[62px] rounded-xl border border-slate-200 bg-slate-50 px-3 py-2">
                        <p className="mb-1 text-[11px] font-bold uppercase tracking-wide text-slate-400">
                          From
                        </p>

                        <p className="break-words text-sm font-medium leading-5 text-slate-700">
                          {formData?.pickupAddress ||
                            "Pickup address not added"}
                        </p>
                      </div>

                      <div className="min-h-[62px] rounded-xl border border-slate-200 bg-slate-50 px-3 py-2">
                        <p className="mb-1 text-[11px] font-bold uppercase tracking-wide text-slate-400">
                          To
                        </p>

                        <p className="break-words text-sm font-medium leading-5 text-slate-700">
                          {formData?.dropAddress || "Drop address not added"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-auto grid w-full grid-cols-1 gap-3 sm:grid-cols-2">
              <button
                type="button"
                disabled={isAccepted}
                onClick={() => setShowCancelModal(true)}
                className={`rounded-2xl border border-red-100 bg-red-50 py-3 font-bold text-red-600 transition hover:bg-red-100 ${
                  isAccepted ? "cursor-not-allowed opacity-50" : ""
                }`}
              >
                Cancel Order
              </button>

              <button
                type="button"
                disabled
                className={`rounded-2xl py-3 font-bold text-white transition ${
                  isAccepted
                    ? "bg-green-600"
                    : "cursor-not-allowed bg-[#1f2d3f] opacity-80"
                }`}
              >
                {isAccepted ? "Captain Accepted" : "Searching Captain..."}
              </button>
            </div>
          </div>

          {/* RIGHT REAL MAP */}
          <div className="order-1 flex h-[420px] bg-slate-100 p-4 sm:h-[460px] md:h-[500px] lg:order-2 lg:h-full lg:p-5">
            <div className="relative h-full w-full overflow-hidden rounded-3xl border border-white/70 bg-white shadow-inner">
              <div ref={mapRef} className="h-full w-full" />
            </div>
          </div>
        </div>
      </section>

      {showCancelModal && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 px-4">
          <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl">
            <div className="mb-4 flex items-center justify-between">
              <div>
                <h3 className="text-lg font-bold text-slate-900">
                  Cancel Order
                </h3>
                <p className="mt-1 text-sm text-slate-500">
                  Please select a cancellation reason.
                </p>
              </div>

              <button
                type="button"
                onClick={() => {
                  setShowCancelModal(false);
                  setCancelReason("");
                }}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-600 hover:bg-slate-200"
              >
                <X size={18} />
              </button>
            </div>

            <div className="mb-5">
              <label className="mb-2 block text-sm font-semibold text-slate-700">
                Cancellation Reason
              </label>

              <select
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
                className="w-full rounded-lg border border-slate-300 bg-white px-3 py-3 text-sm text-slate-700 outline-none focus:border-red-400 focus:ring-2 focus:ring-red-100"
              >
                <option value="">Select reason</option>

                {cancellationReasons.map((reason) => (
                  <option key={reason} value={reason}>
                    {reason}
                  </option>
                ))}
              </select>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              <button
                type="button"
                onClick={() => {
                  setShowCancelModal(false);
                  setCancelReason("");
                }}
                className="rounded-lg border border-slate-200 bg-white py-3 font-bold text-slate-700 hover:bg-slate-50"
              >
                Keep Order
              </button>

              <button
                type="button"
                disabled={!cancelReason}
                onClick={handleCancelConfirm}
                className={`rounded-lg py-3 font-bold text-white transition ${
                  cancelReason
                    ? "bg-red-600 hover:bg-red-700"
                    : "cursor-not-allowed bg-red-300"
                }`}
              >
                Confirm Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CaptainSearchingCard;

